
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/abbonamenti",
      function () {
        return require("private-next-pages/dashboard/abbonamenti/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/abbonamenti"])
      });
    }
  